const DOBBY_URL = process.env.REACT_APP_DOBBY_URL
const RAVEN_URL = process.env.REACT_APP_RAVEN_URL
const TYRION_URL = process.env.REACT_APP_TYRION_URL
const TRUBEL_URL = process.env.REACT_APP_TRUBEL_URL
const LEGOLAS_URL = process.env.REACT_APP_LEGOLAS_URL
const XAVIER_URL = process.env.REACT_APP_XAVIER_URL

export const VENUE_LIST_API = DOBBY_URL + '/api/v1/venue'
export const VENUE_CUSTOM_META_DATA_API = DOBBY_URL + '/api/v1/metadata/custom/venue'
export const SYSTEM_METADATA_API = DOBBY_URL + '/api/v1/metadata/system'

export const ARTIST_TYPE_LIST_API = DOBBY_URL + '/api/v1/artist/artist-type'
export const CONTENT_RATING_API = DOBBY_URL + '/api/v1/metadata/rating'
export const ARTIST_LIST_API = DOBBY_URL + '/api/v1/artist'
export const ARTIST_LISTING = XAVIER_URL + '/api/v1/artist'
export const VENUE_LISTING = XAVIER_URL + '/api/v1/venue'
export const ARTIST_CUSTOM_META_DATA_API = DOBBY_URL + '/api/v1/metadata/custom/artist'
export const CAMPAIGN_CUSTOM_META_DATA_API = DOBBY_URL + '/api/v1/metadata/custom/campaign'
export const AUDIENCE_CUSTOM_META_DATA_API = DOBBY_URL + '/api/v1/metadata/custom/campaign-audience'
export const Mail_Template_CUSTOM_META_DATA_API =
  DOBBY_URL + '/api/v1/metadata/custom/email-template'
export const DOBBY_ANALYTICS_API = DOBBY_URL + '/api/v1/analytics'
export const META_DATA_URL = DOBBY_URL + `/api/v1/metadata`
export const IPTV_CHANNEL_API = DOBBY_URL + `/api/v1/content/iptv-channel`
export const IPTV_CHANNEL_FILTER = DOBBY_URL + `/api/v2/content/iptv-channel-filter`
export const CUSTOM_FORM_API = DOBBY_URL + `/api/v1/custom-forms`
export const CUSTOM_FORM_ANALYTICS = DOBBY_URL + `/api/v1/custom-forms/response/analytics`
export const CUSTOM_FORM_ANALYTICS_DOWNLOAD =
  DOBBY_URL + `/api/v1/custom-forms/response/analytics/download`
export const LEAD_PARTNER_ANALYTICS = DOBBY_URL + `/api/v1/custom-forms/lead-partner/analytics`

export const TEMPLATE_V2_URL = RAVEN_URL + '/api/v2/template'
export const BASE_TEMPLATE = RAVEN_URL + '/api/v2/template/base-templates'
export const BASE_COMPONENTS = RAVEN_URL + '/api/v2/template/base-components'

export const ROLE_LIST_API = RAVEN_URL + '/api/v1/role'
export const ROLE_SCHEMA_API = RAVEN_URL + '/api/v1/role/schema'

export const USER_API = RAVEN_URL + '/api/v1/user'
export const ACTIVATE_USER_ACCOUNT = RAVEN_URL + '/api/v1/user/activate'
export const RESET_USER_PASSWORD = RAVEN_URL + '/api/v1/user/reset-password/cms'
export const CHANGE_PASSWORD = RAVEN_URL + '/api/v1/user/change-password'
export const DEACTIVATE_USER_ACCOUNT = RAVEN_URL + '/api/v1/user/deactivate'
export const ACCOUNT_API = RAVEN_URL + '/api/v1/account'
export const LEAD_API = RAVEN_URL + '/api/v1/leads/listing'
export const LEAD_UPDATE_API = RAVEN_URL + '/api/v1/leads/update'

export const COUNTRY_API = RAVEN_URL + '/api/v1/config/country-master'
export const ACCOUNT_CONFIG_API = RAVEN_URL + '/api/v1/account/config'
export const SUBSCRIBER_API = RAVEN_URL + '/api/v1/user/subscriber'
export const TEMPLATE_API = RAVEN_URL + '/api/v1/template'
export const RAVEN_ANALYTICS_API = RAVEN_URL + '/api/v1/analytics'
export const CUSTOM_PAGES_API = RAVEN_URL + '/api/v1/custom-page'
export const CAMPAIGN_API = RAVEN_URL + '/api/v1/campaign'
export const EMAIL_TEMPLATES_API = RAVEN_URL + '/api/v1/email-template'
export const AUDIENCE_API = RAVEN_URL + '/api/v1/campaign/audience'
export const AUDIENCE_SOURCE_COUNT_API = RAVEN_URL + '/api/v1/campaign/audience/count'
export const SUBSCRIBER_USER_API = RAVEN_URL + '/api/v1/user/subscriber/list'

export const MASTER_ORGS_API = TYRION_URL + '/api/v1/payment-gateway/orgs'
export const CUSTOMER_ORGS_API = TYRION_URL + '/api/v1/payment-gateway/customer-org'

export const SUBSCRIPTION_API = TYRION_URL + '/api/v1/subscription'
export const ANALYTICS_API = TYRION_URL + '/api/v1/analytics'

export const TRANSACTION_CAPTURE = TYRION_URL + '/api/v1/payment/get-transaction-status'
export const TAX_HEAD_API = TYRION_URL + '/api/v1/payment/tax-head'

export const DISCOUNT_MASTER_API = TYRION_URL + '/api/v1/payment/discount-master'
export const DISCOUNT_API = TYRION_URL + '/api/v1/payment/discount'

export const CONTENT_LIST_API = DOBBY_URL + '/api/v1/content'
export const CONTENT_LIST_FILTER_API = DOBBY_URL + '/api/v2/content/filter'
export const ASSET_API = DOBBY_URL + '/assets'
export const JOB_STATUS_API = DOBBY_URL + '/asset/upload'
export const PLAYLIST_METADATA = DOBBY_URL + '/api/v1/content/generate-playlist-metadata'
export const DOBBY_BASE_URL = DOBBY_URL

export const TRANSCODE_API = LEGOLAS_URL + '/transcode'

export const LIVE_STREAM_API = DOBBY_URL + '/api/v1/live'
export const LIVE_STREAM_START_API = DOBBY_URL + '/api/v1/live/start'
export const LIVE_STREAM_STOP_API = DOBBY_URL + '/api/v1/live/stop'
export const LIVE_STREAM_FILTER_API = DOBBY_URL + '/api/v1/live/filter'
export const LIVE_INBOUND_API = DOBBY_URL + '/api/v1/live/inbound-resolution'

export const AFFILIATES_API = TYRION_URL + '/api/v1/affiliates'
export const AFFILIATES_ANALYTICS_API = TYRION_URL + '/api/v1/affiliates/analytics'
export const CONTENT_FILTER_XAVIER = XAVIER_URL + '/api/v2/content/filter'
export const CONTENT_FILTER_XAVIER_V1 = XAVIER_URL + '/api/v1/content/filter'

export const EMAIL_TEMPLATE_API = RAVEN_URL + '/api/v1/email-template'

export const VIEW_CARD_API = TRUBEL_URL + '/api/v1/load/view-card'
export const WATCHTIME_TRAFFIC_API = TRUBEL_URL + '/api/v1/load/watchtime-traffic'
export const CONTENT_WATCH_REPORT_API = TRUBEL_URL + '/api/v1/load/content-watch-report'
export const USER_WATCH_REPORT_API = TRUBEL_URL + '/api/v1/load/user-content-watch-report'
